import resolveAudioUrl from "../../../../utils/audio/resolveAudioUrl";

export default function TargetAudioPlayer({ sample, onPlay, constructLabel, inputRef, invalid = false, validationMessage }) {
  if (!sample?.sampleLink) return null;
  const context = constructLabel ? ` for ${constructLabel}` : "";
  return (
    <div className="av-target-audio" data-invalid={invalid || undefined}>
      <p className="byce-task__section-label">Target voice</p>
      <audio
        ref={inputRef}
        aria-label="Target voice recording"
        aria-invalid={invalid || undefined}
        aria-describedby={invalid && validationMessage ? "target-playback-validation" : undefined}
        title={context ? `Target voice${context}` : "Target voice"}
        controls
        tabIndex="0"
        preload="metadata"
        controlsList="nodownload"
        src={resolveAudioUrl(sample.sampleLink)}
        onPlay={onPlay}
      />
      {invalid && validationMessage && <p id="target-playback-validation" className="av-target-audio__validation">{validationMessage}</p>}
    </div>
  );
}
